import React from "react";

const BikeRubbingAndCoating = () => {
  return (
    <div className="space-y-2 text-sm text-gray-800">
      <p className="font-semibold">Includes:</p>
      <ul className="list-disc text-black-500">
        <li>Removes minor scratches</li>
        <li>Restores gloss and color</li>
        <li>Glass & visor polishing</li>
        <li>Premium long-lasting wax shine</li>
        <li>Strong UV paint protection</li>
        <li>Foam wash before & after</li>
        <li>Tyre & plastic dressing</li>
        <li>Machine polish ultra-smooth finish</li>
      </ul>
    </div>
  );
};

export default BikeRubbingAndCoating;

